import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <h4>{`We're a group of Android and Tech enthusiasts who are hardcore Anime otakus. #animeislifu`}</h4>
    <p>{`Our members initially started off forming with five of us using an Android custom ROM, Havoc OS. We were rather active in their
Telegram support chat, and slowly got to know each other better. Eventually, we made a group on Telegram and started tinkering playing
with code, building custom ROMs and learning new languages. Since then, we've kept building, modifying, forked and written our open-source
projects on GitHub, which led to where we are now.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      